import { render, staticRenderFns } from "./AuthenticationBase.vue?vue&type=template&id=ebec232e&scoped=true&"
import script from "./AuthenticationBase.vue?vue&type=script&lang=js&"
export * from "./AuthenticationBase.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationBase.vue?vue&type=style&index=0&id=ebec232e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebec232e",
  null
  
)

export default component.exports